import React, { useState } from 'react';
import { useI18n } from '@whizz/react-i18n';
import classNames from 'classnames';
import { Alert, Toggle } from '../../../components';
import { InfoButton } from '../../../global';

interface Props {
  toggled: boolean;
  toggleHandler: (toggle: boolean) => () => void;
}

const SensitiveDataToggle = ({ toggled, toggleHandler }: Props): JSX.Element => {
  const { translate } = useI18n();
  const [ showInfo, setShowInfo ] = useState(false);

  return (
    <div className={'container rounded-default bg-white shadow-sm'} data-hide-print>
      <div className={'w-full md:w-auto md:inline-flex items-center justify-end space-x-2'}>
        <div className={'text-sm font-bold'}>{translate('pages.REPORTS.SENSITIVE_DATA.LABEL')}</div>
        <div className={'flex items-center'}>
          <div className={'flex items-center justify-center md:ml-4'}>
            <button className={'appearance-none'} type={'button'} onClick={toggleHandler(false)}>
              <div className={`text-sm transition-opacity ${classNames({ 'opacity-50' : toggled }, { 'font-bold' : !toggled })}`}>
                {translate('components.BUTTONS.HIDE')}
              </div>
            </button>
            <div className='mx-3'>
              <Toggle
                id={'sensitive-data'}
                label={translate('pages.REPORTS.SENSITIVE_DATA.LABEL')}
                color={'header'}
                checked={toggled}
                isOnOff
                onChange={toggleHandler(!toggled)}
              />
            </div>
            <button className={'appearance-none'} type={'button'} onClick={toggleHandler(true)}>
              <div className={`text-sm transition-opacity ${classNames({ 'opacity-50' : !toggled }, { 'font-bold' : toggled })}`}>
                {translate('components.BUTTONS.SHOW')}
              </div>
            </button>
          </div>
          <InfoButton onClick={() => setShowInfo((prev) => !prev)} />
        </div>
      </div>
      <Alert disableIcon show={showInfo} className={'w-full p-4'}>
        {translate('pages.REPORTS.SENSITIVE_DATA.INFO')}
      </Alert>
    </div>
  );
};

export default SensitiveDataToggle;
